export default ['personal-information', 'address', 'income', 'insurance'];



// WEBPACK FOOTER //
// ./src/common/enums/onboardingSteps.js